module.exports = __webpack_public_path__ + "img/hochmut.06ebacc1.png";